import React from 'react';
import { ArrowRightOutlined, InboxOutlined } from '@ant-design/icons';
import { FeatureJobApplications } from '../models/featurejobapplications.model';
import {
  formatDashboardDate,
  getPersonInitials,
} from '../utils/dashboard.utils';
import {
  formatStageLabel,
  getPipelineColumnTone,
} from '../../job-application/utils/pipeline-board.utils';

interface Props {
  applications: FeatureJobApplications[];
  onOpenApplication: (applicationId: string) => void;
  onViewAll: () => void;
}

const RecentApplicationsPanel: React.FC<Props> = ({
  applications,
  onOpenApplication,
  onViewAll,
}) => (
  <section
    className="dashboard-panel dashboard-applications"
    aria-labelledby="recent-applications-title"
  >
    <header className="dashboard-panel__header">
      <h2 id="recent-applications-title">Recent applications</h2>
      <button className="dashboard-link" type="button" onClick={onViewAll}>
        View all applications <ArrowRightOutlined aria-hidden />
      </button>
    </header>

    {applications.length === 0 ? (
      <div className="dashboard-empty" role="status">
        <InboxOutlined aria-hidden />
        <strong>No applications yet</strong>
        <span>New candidates will appear here as soon as they apply.</span>
      </div>
    ) : (
      <div className="dashboard-table-scroll">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th scope="col">Candidate</th>
              <th scope="col">Job</th>
              <th scope="col">Stage</th>
              <th scope="col">Applied</th>
            </tr>
          </thead>
          <tbody>
            {applications.map((application) => {
              const candidateName = application.candidate || 'Candidate';
              const status = application.status || '';
              const tone = getPipelineColumnTone(status);

              return (
                <tr key={application.id}>
                  <td>
                    <button
                      className="dashboard-candidate"
                      type="button"
                      onClick={() => onOpenApplication(application.id)}
                    >
                      <span className="dashboard-candidate__avatar" aria-hidden>
                        {getPersonInitials(candidateName)}
                      </span>
                      <span className="dashboard-candidate__copy">
                        <strong>{candidateName}</strong>
                        <small>
                          {application.email || 'No email available'}
                        </small>
                      </span>
                    </button>
                  </td>
                  <td>{application.jobName || 'Job unavailable'}</td>
                  <td>
                    <span
                      className={`dashboard-status dashboard-status--${tone}`}
                    >
                      {formatStageLabel(status)}
                    </span>
                  </td>
                  <td>{formatDashboardDate(application.appliedOn)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export default RecentApplicationsPanel;
